import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ordersService } from '../../services/orders.service';
import * as moment from 'moment';
import { RegisterService } from 'src/app/auth/container/registration-module/register.service';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import { error } from 'jquery';

@Component({
  selector: 'app-push-to-vendor',
  templateUrl: './push-to-vendor.component.html',
  styleUrls: ['./push-to-vendor.component.css']
})
export class pushToVendorComponent {
  @ViewChild('filterDropdown') filterDropdown!: ElementRef;
  group: any;
  associateData: any;
  showSelectionCard: boolean = false;
  pageNumber = 0;
  pageSize = 1000;
   sortingCol : string = 'id';
  direction : string = 'DESC' 
  labourList: any;
  finalAcceptance: boolean = false;
  associateAcceptance: boolean = false;
  shortlist: boolean = false
  jobLineItems: any = null;
  searchDropDownToggle: boolean = false;
  selectedSkill: any;
  allSkills: string[] = [];
  quickCodeCategoryList: any;
  allCatagory: any;
  sendCatagoryId: (number | undefined)[];
  skillSetList: any;
  educationList: any;

  yearOfExperience = [
    { id: 1, name: 1 },
    { id: 2, name: 2 },
    { id: 3, name: 3 },
    { id: 4, name: 4 },
    { id: 5, name: 5 },
    { id: 6, name: 6 },
    { id: 7, name: 7 },
    { id: 8, name: 8 },
    { id: 9, name: 9 },
    { id: 10, name: 10 },
    { id: 11, name: 11 },
    { id: 12, name: 12 },
    { id: 13, name: 13 },
    { id: 14, name: 14 },
    { id: 15, name: 15 },
    { id: 16, name: 16 },
    { id: 17, name: 17 },
    { id: 18, name: 18 },
    { id: 19, name: 19 },
    { id: 20, name: 20 },
  ];
  selectedExperience: any;

  filter = {
    shortlist: false,
    associateAcceptance: false,
    finalAcceptance: false
  };
  postData: any;
  filters: any;
  vendorLists: any;
  selectedRows: any[] = [];
  isAllSelected: any;
  orderParentData: any;
vendorName: string = '';
  private searchSubject = new Subject<string>();


  constructor(private fb: FormBuilder,
    public dialogService: DialogService,
    public dialogRef: DynamicDialogRef,
    public data: DynamicDialogConfig,
    public orderService: ordersService,
    private emsServices: EmsServicesService,
    private registerService: RegisterService) {

    // this.quickCodeCategoryList = JSON.parse(localStorage.getItem('category')!);
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!);
    this.sendCatagoryId = this.setId();

    console.log(this.sendCatagoryId)
    this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString())

    this.associateData = data?.data?.childData;
    this.orderParentData = data?.data?.parentData;
    console.log( this.associateData,' this.associateData')
    setTimeout(() => {
      this.getVendorInfo();
      this.patchData(this.associateData);
    }, 500);


    // subscribe to searchSubject with debounce
    // this.searchSubject.pipe(
    //   debounceTime(400),
    //   distinctUntilChanged(),
    //   switchMap((term: string) => this.vendorService.searchVendors(term))
    // )
    // .subscribe((res: any) => {
    //   this.vendorList = res?.responseObject || [];
    // });

  }

   onSearchvendorName(value: string) {
    let payload: any[] = [];

    if (value && value.trim() !== '') {
      payload = [
        {
          key: 'VENDOR_NAME_IN',
          value: value.trim()
        }
      ];
    }
    this.emsServices
      .getVendorInfo(payload, this.pageNumber, this.pageSize,this.sortingCol,this.direction)
      .subscribe((data: any) => {
      this.showmapingData(data?.responseObject?.content);

      },err => {
        this.showmapingData('');
      })
  // }
}

  ngOnInit(): void {
    // this.associateData.jobLineItems.forEach((item: any) => {
    //   item.updatedWage = item.vendorPrice != null && item.vendorPrice !== '' ? item.vendorPrice : item.maxSalary;
    // });
    // console.log('jobAssociateMappingjobAssociateMapping', this.associateData?.jobAssociateMapping)
    // console.log("tetette", this.labourList)
  }

  patchData(data: any) {
    if (data) {
      // console.log("DATA AT ASSOCIATW PAGE: " + JSON.stringify(data));
    }
  }

  showAssociate() {
    this.showSelectionCard = true;
    this.getAssociateList();
  }

  getUniqueSkills(): string {
    const skillSet = new Set<string>();

    this.associateData?.jobLineItems?.forEach((item: any) => {
      if (item.skill) {
        skillSet.add(item.skill);
      }
    });

    return Array.from(skillSet).join(', ');
  }

  // getAssociateList() {
  //   console.log(this.jobLineItems)
  //   const payload = [
  //     {
  //       "key": "VENDOR_ID_IN",
  //       "value": "1"
  //     },
  //     {
  //       "key": "USER_TYPE",
  //       "value": "ASSOCIATE"
  //     },
  //     {
  //       'key': 'SKILL_IN',
  //       'value': this.jobLineItems?.skillId
  //     }
  //   ]
  //   this.orderService.getAssociateList(payload, this.pageNumber, this.pageSize).subscribe({
  //     next: (res: any) => {
  //       this.labourList = res?.responseObject?.content.map((labour: any) => {
  //         return {
  //           ...labour,
  //           age: this.getAgeFromDob(labour?.dateOfBirth),
  //           skill: ' Picker test',
  //           finalAcceptance: false,
  //           associateAcceptance: false,
  //           shortlist: false

  //         }
  //       })

  //       this.showmapingData(this.labourList)
  //     }
  //   })
  // }

 getAssociateList() {
  const payload = [
    { key: 'VENDOR_ID_IN', value: '1' },
    { key: 'USER_TYPE', value: 'ASSOCIATE' }
  ];

  if (this.selectedSkill?.length > 0) {
    payload.push({ key: 'SKILL_IN', value: this.selectedSkill.join(',') });
  }

  if (this.selectedExperience?.length > 0) {
    payload.push({ key: 'EXPERIENCE_IN', value: this.selectedExperience.join(',') });
  }

  this.orderService.getAssociateList(payload, this.pageNumber, this.pageSize).subscribe({
    next: (res: any) => {
      let data = res?.responseObject?.content.map((labour: any) => ({
        ...labour,
        age: this.getAgeFromDob(labour?.dateOfBirth),
        shortlist: false,              
        associateAcceptance: false,    
        finalAcceptance: false         
      }));

      this.showmapingData(data);
      
      this.labourList = this.labourList.filter((labor: any) => {
        if (this.filter.shortlist && !labor.shortlist) return false;
        if (this.filter.associateAcceptance && !labor.associateAcceptance) return false;
        if (this.filter.finalAcceptance && !labor.finalAcceptance) return false;
        return true;
      });

      console.log("Filtered labourList", this.labourList);
    }
  });
}


getVendorInfo() {
    this.postData = [
      // {    
      //   "key": "USER_TYPE",
      //   "value": "2"
      // },
      // {
      //   "key":"PLATFORM_IN",
      //   "value":"ems"
      // }
    ]

    if (this.filters) {
      Object.values(this.filters).forEach((filter: any) => {
        this.postData.push(filter);
      });
    }
    this.emsServices
      .getVendorInfo(this.postData, this.pageNumber, this.pageSize,this.sortingCol,this.direction)
      .subscribe((data: any) => {
        // this.vendorLists = data?.responseObject?.content;
        // console.log(this.vendorLists);
        // const data1 = data?.responseObject?.content.map((labor: any) => {
        //   const match = this.associateData?.find(
        //     (vendorId: any) => vendorId?.vendorId === labor.id
        //   );

        //   if (match) {
        //     console.log("match found", match);
        //     return {
        //       ...labor,
        //       selected: true,
        //       // associateAcceptance: match.associateAcceptance ?? false,
        //       // finalAcceptance: match.finalAcceptance ?? false
        //     };
        //   }

        //   // No match, default false values
        //   return {
        //     ...labor,
        //       selected: false,

        //     // shortlist: labor.shortlist ?? false,
        //     // associateAcceptance: labor.associateAcceptance ?? false,
        //     // finalAcceptance: labor.finalAcceptance ?? false
        //   };
        // });
        this.showmapingData(data?.responseObject?.content);
// this.labourList = data1
// console.log(this.labourList)
// console.log(data1)
        // this.totalCount = data?.responseObject.totalElements;
      });
  }

  setId(): (number | undefined)[] {
    const keys = [
      'skillSet', 'education'
    ];
    return keys.map(key => this.allCatagory?.[key]?.id);
  }

  getQuickCodeListByCategoryId(ids: any) {
    this.registerService.getQuickCodeListByCategoryId(ids).subscribe({
      next: (res: any) => {
        const categoryData = res?.responseObject;
        this.skillSetList = categoryData?.skillSet;
      }
    })
  }

  // showmapingData(labourList: any) {
  //   console.log('labourList', labourList)
  //   console.log("this.associateData?.jobAssociateMapping", this.associateData?.jobAssociateMapping)
  //   this.labourList = this.labourList.map((labor: any) => {
  //     const match = this.associateData?.jobAssociateMapping.find(
  //       (mapping: any) => mapping?.associateId === labor.id
  //     );
  //     if (match) {
  //       console.log("match", match)
  //       return {
  //         ...labor,
  //         shortlist: match.shortlist,
  //         associateAcceptance: match.associateAcceptance,
  //         finalAcceptance: match.finalAcceptance
  //       };
  //     }
  //     return labor;
  //   });

  //   console.log("match", this.labourList)
  // }

  showmapingData(labourList: any) {
  console.log('labourList', labourList);
  console.log("this.associateData?.jobAssociateMapping", this.associateData);

  // Merge mapping data with associates
  if(labourList.length > 0){
  this.vendorLists = labourList.map((labor: any) => {
    const match = this.associateData?.find(
      (vendorId: any) => vendorId?.vendorId === labor.id
    );

    if (match) {
      console.log("match found", match);
      return {
        ...labor,
        selected: true,
      };
    }

    // No match, default false values
    return {
      ...labor,
        selected: false,
    };
  });
  }else{
    this.vendorLists = []
  }

  console.log("Updated labourList with mapping", this.vendorLists);
}

  getAgeFromDob(dob: string): number {
    if (!dob) return 0;
    const birthDate = moment(dob, 'DD-MM-YYYY HH:mm:ss Z');
    return moment().diff(birthDate, 'years');
  }

  reset() {
    this.selectedSkill = [];
    this.selectedExperience = [];
    this.getAssociateList();
  }


  applyFilter() {
    this.getAssociateList()
    this.searchDropDownToggle = false;
  }

  submit(type: 'SUBMIT' | 'DRAFT') {
    let selectedAssociateIds: any
    // console.log("this.jobLineItems",this.jobLineItems)
    // console.log("this.associateData",this.associateData)
    // selectedAssociateIds = this.labourList
    //   .filter((labor: any) => labor.shortlist)
    //   .map((labor: any) => labor);
    // if (selectedAssociateIds?.length == 0) {
    //   selectedAssociateIds = this.labourList
    //     .filter((labor: any) => labor.finalAcceptance)
    //     .map((labor: any) => labor);
    // }
    // console.log("selectedAssociateIds",selectedAssociateIds)

    let jobAssociateMapping = [];

    // for (const skill of this.associateData.jobLineItems) {
    // for (const associateId of selectedAssociateIds) {
    //   jobAssociateMapping.push({
    //     price: this.jobLineItems.updatedWage,
    //     skillId: this.jobLineItems.skillId,
    //     associateId: associateId.id,
    //     // id: associateId.id ? associateId.id : '',
    //     // status: 'PendingOnUser',
    //     shortlist: associateId.shortlist,
    //     // associateAcceptance: associateId.associateAcceptance,
    //     finalAcceptance: associateId.finalAcceptance
    //   });
    // }
    // }

//      jobAssociateMapping = jobAssociateMapping.map((labor: any) => {
//   const matchAssociate = this.associateData?.jobAssociateMapping.find(
//     (Associate: any) => Associate?.associateId === labor.associateId
//   );
//   if (matchAssociate) {
//     console.log("match",matchAssociate)
//     return {
//       ...labor,
//       id:matchAssociate.id
//     };
//   }
//   return labor;
// });


   


   const ids = this.selectedRows.map(item => item.id);
console.log(ids); 
 const payload = {
      id:this.orderParentData?.id,
      status: 'PendingOnVendor',
      vendorIds: ids,
      version: this.orderParentData?.version
    };

console.log("payload",ids)
    this.orderService.updateLineItems(payload).subscribe({
      next: (res: any) => {
        this.dialogRef.close(true)
      }
    })
  }

  selectAll = {
    selected: false,
    associateAcceptance: false,
    finalAcceptance: false
  };

  toggleAll(field: 'selected', checked: any) {
    // console.log(checked,"checked")
    // update all rows  
    const isChecked = checked?.target?.checked;
  console.log(isChecked, "checked");

  this.vendorLists.forEach((labor: any) => {
    labor[field] = isChecked;
  });

  // rebuild selectedRows
  this.selectedRows = this.vendorLists.filter((labor: any) => labor[field]);

  // console.log("selectedRows", this.selectedRows);
  }

 isDisabled(row: any) {
    return row.selected && this.associateData.find((r:any) => r.vendorId === row.id);
  }

  onRowSelect(row: any) {

    if (row.selected) {
    const exists = this.selectedRows.find((r: any) => r.id === row.id);
    if (!exists) {
      this.selectedRows.push(row);
    }
  } else {
    this.selectedRows = this.selectedRows.filter((r: any) => r.id !== row.id);
  }

    // console.log("re",row)

    // if (row) {
    //   this.selectedRows = []
    //   this.selectedRows.push(row);
    // }
    // if (row.selected) {
    //   this.selectedRows = this.vendorLists.filter((r:any) => r.selected);
    // } else {
    // this.selectedRows = this.vendorLists.filter((r:any) => r.selected);

    // }

    console.log(this.selectedRows)
  }
}
